var AnalyticsEvents = /* @__PURE__ */ function(AnalyticsEvents2) {
  AnalyticsEvents2["DashboardVisit"] = "Dashboard Visit";
  AnalyticsEvents2["EmailLogin"] = "Email Login";
  AnalyticsEvents2["OAuthLogin"] = "OAuth Login";
  AnalyticsEvents2["Logout"] = "Logout";
  AnalyticsEvents2["CreatedFdoc"] = "Created Fdoc";
  AnalyticsEvents2["CreatedComment"] = "Created Comment";
  AnalyticsEvents2["CreatedSpace"] = "Created Space";
  AnalyticsEvents2["CreatedTag"] = "Created Tag";
  AnalyticsEvents2["RenamedTag"] = "Renamed Tag";
  AnalyticsEvents2["AssignTag"] = "Assign Tag";
  AnalyticsEvents2["UnassignTag"] = "Unassign Tag";
  AnalyticsEvents2["PinResources"] = "Pin resources";
  AnalyticsEvents2["UnpinResources"] = "Unpin resources";
  AnalyticsEvents2["ClickedAddIntegration"] = "Integration: Clicked Add Integration";
  AnalyticsEvents2["ConfirmedAddGoogleAccount"] = "Integration: Confirmed Add Google Account";
  AnalyticsEvents2["ConnectedGoogleDrive"] = "Integration: Connected Google Drive";
  AnalyticsEvents2["DeletedGoogleDrive"] = "Integration: Deleted Google Drive";
  AnalyticsEvents2["ClickedAddGithubAccount"] = "Integration: Clicked Add Github Account";
  AnalyticsEvents2["DeletedIntegration"] = "Integration: Deleted";
  AnalyticsEvents2["RegisteriOSDevice"] = "Integration: Register iOS Screenshots Device";
  AnalyticsEvents2["PausediOSDevice"] = "Integration: Paused iOS Screenshots Device";
  AnalyticsEvents2["PausedConnection"] = "Integration: Paused Connection";
  AnalyticsEvents2["ResumedConnection"] = "Integration: Resumed Connection";
  AnalyticsEvents2["MigratedFromOtherApp"] = "Migrated From Other App";
  AnalyticsEvents2["FirstArrival"] = "First Arrival";
  AnalyticsEvents2["DeletedResource"] = "Deleted Resource";
  AnalyticsEvents2["DeletedComment"] = "Deleted Comment";
  AnalyticsEvents2["DeletedSpace"] = "Deleted Space";
  AnalyticsEvents2["LeftSpace"] = "Left Space";
  AnalyticsEvents2["DeletedTag"] = "Deleted Tag";
  AnalyticsEvents2["EditedComment"] = "Edited Comment";
  AnalyticsEvents2["RenamedSpace"] = "Renamed Space";
  AnalyticsEvents2["RenamedResource"] = "Renamed Resource";
  AnalyticsEvents2["MovedItems"] = "Moved Items";
  AnalyticsEvents2["ViewFdoc"] = "View Fdoc";
  AnalyticsEvents2["OpenSpace"] = "Open Space";
  AnalyticsEvents2["OpenFolder"] = "Open Folder";
  AnalyticsEvents2["OpenTag"] = "Open Tag";
  AnalyticsEvents2["OpenIntegration"] = "Open Integration";
  AnalyticsEvents2["VisitedSharedLink"] = "Visited Shared Link";
  AnalyticsEvents2["ChangeLabel"] = "Change Label";
  AnalyticsEvents2["RemovedLabel"] = "Removed Label";
  AnalyticsEvents2["RenameLabel"] = "Rename Label";
  AnalyticsEvents2["InstalledDesktop"] = "Installed Desktop";
  AnalyticsEvents2["InstallediOS"] = "Installed iOS";
  AnalyticsEvents2["InstalledAndroid"] = "Installed Android";
  AnalyticsEvents2["InstalledExtension"] = "Installed Extension";
  AnalyticsEvents2["Search"] = "Search";
  AnalyticsEvents2["NotepadEdit"] = "Notepad Edit";
  AnalyticsEvents2["VotedForDataConnection"] = "Voted For Data Connection";
  AnalyticsEvents2["ClickedUpgrade"] = "Clicked Upgrade";
  AnalyticsEvents2["ClickedDowngrade"] = "Clicked Downgrade";
  AnalyticsEvents2["ClickedManagePlan"] = "Clicked Manage Plan";
  AnalyticsEvents2["ClickedRestorePurchase"] = "Clicked Restore Purchase";
  AnalyticsEvents2["ChatbotDocumentChatMessage"] = "Assistant Document Chat Message";
  AnalyticsEvents2["ChatbotSearchChatMessage"] = "Assistant Search Chat Message";
  AnalyticsEvents2["ChatbotChatMessage"] = "Assistant Chat Message";
  AnalyticsEvents2["ChatbotQuotaLimitHit"] = "Assistant Quota Limit Hit";
  AnalyticsEvents2["Error"] = "Error";
  AnalyticsEvents2["MagicRename"] = "Magic Rename";
  AnalyticsEvents2["ClickUpgradeFromHome"] = "Clicked Upgrade from Home";
  AnalyticsEvents2["DeleteConnectionMirror"] = "Delete connection mirror";
  AnalyticsEvents2["SharingEmailInvitationCreate"] = "Sharing: Email invitation sent";
  AnalyticsEvents2["SharingEmailInvitationDelete"] = "Sharing: Email invitation deleted";
  AnalyticsEvents2["SharingEnabledPublicLink"] = "Sharing: Enabled public link";
  AnalyticsEvents2["SharingDisabledPublicLink"] = "Sharing: Disabled public link";
  AnalyticsEvents2["SharingUserRemoved"] = "Sharing: User removed";
  AnalyticsEvents2["SharingUserRoleUpdated"] = "Sharing: User role updated";
  AnalyticsEvents2["SharingAcceptInvitation"] = "Sharing: Invitation accepted (Joined Resource)";
  AnalyticsEvents2["InAppRatingRatingSubmitted"] = "In App Rating: rating submitted";
  AnalyticsEvents2["InAppRatingFeedbackSubmitted"] = "In App Rating: feedback submitted";
  AnalyticsEvents2["InAppRatingDismissed"] = "In App Rating: dismissed";
  AnalyticsEvents2["ExtensionActivity"] = "Extension Activity";
  AnalyticsEvents2["OpenExtensionPopup"] = "Opened Extension Popup";
  AnalyticsEvents2["SmartCollectionCreated"] = "Smart Collection: Created";
  AnalyticsEvents2["SmartCollectionDeleted"] = "Smart Collection: Deleted";
  AnalyticsEvents2["SmartCollectionUpdated"] = "Smart Collection: Updated";
  AnalyticsEvents2["ReferralCodeApplied"] = "Referral: Code Applied";
  AnalyticsEvents2["ReferralInvitePageVisited"] = "Referral: Invite Page Visited";
  AnalyticsEvents2["ReferralCodeCopy"] = "Referral: Code Copied to clipboard";
  AnalyticsEvents2["ReferralSignupVisited"] = "Referral: Signup visited with referral code";
  AnalyticsEvents2["OnboardingFormStepCompleted"] = "Onboarding form: Form Step Completed";
  AnalyticsEvents2["SubscriptionLimitBannerShown"] = "Subscription Limit Banner: Shown";
  AnalyticsEvents2["SubscriptionLimitBannerDismissed"] = "Subscription Limit Banner: Dismissed";
  AnalyticsEvents2["SubscriptionLimitBannerClicked"] = "Subscription Limit Banner: Clicked";
  AnalyticsEvents2["FabricLabsUpsellBannerShown"] = "Fabric Labs: Upsell Banner Shown";
  AnalyticsEvents2["FabricLabsToggleFeature"] = "Fabric Labs: Toggle Feature";
  return AnalyticsEvents2;
}({});

export { AnalyticsEvents };
//# sourceMappingURL=analytics.types.js.map
